(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabObjectsTypesPropertiesDialogController', TabObjectsTypesPropertiesDialogController);

    TabObjectsTypesPropertiesDialogController.$inject = ['$uibModalInstance','warnings'];

    function TabObjectsTypesPropertiesDialogController($uibModalInstance, warnings) {
        var vm = this;
        vm.warnings = warnings;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.go = function () {
            $uibModalInstance.close(true);
        };
    }
})();
